import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Subfee.UploadFile.IRequest;
type Response = Api.Core.Subfee.UploadFile.IResponse;
type Headers = Api.Core.Subfee.UploadFile.IHeaders;
const apiSubfeeUploadFilePath = '/api/ProductManagement/Subfee/:id/Documents';
export default async function subfeeUploadFileApi(id: number, request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiSubfeeUploadFilePath, { id }),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
